// let menuBtn = document.querySelector('.menu-btn');
// let menu = document.querySelector('.header-menu ul');

// menuBtn.addEventListener('click', function() {
//     menu.classList.toggle('active');
// })



AOS.init({disable: 'mobile'});



let menuToggle = document.querySelector('.header-bars');
let menuMobile = document.querySelector('.header-mobile');

menuToggle.addEventListener('click', () => {
    menuToggle.classList.toggle('active');
    menuMobile.classList.toggle('active');
})


$(window).on('load scroll', function () {
    console.log($('.header'))
    if ($(this).scrollTop() >= '1') {
        $('.header').addClass('active')
    } else {
        $('.header').removeClass('active')
    }
});

